/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconArrowUp8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowUp8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path d="m1.59 5.256 2.43-2.431 2.432 2.43.47-.47-2.901-2.903-2.903 2.902.472.472Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconArrowUp12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowUp12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M2.384 7.884 6.03 4.237l3.647 3.647.707-.707L6.03 2.823 1.677 7.177l.707.707Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowUp16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowUp16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M3.178 10.512 8.04 5.65l4.862 4.862.943-.943L8.04 3.764 2.235 9.57l.943.943Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowUp20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowUp20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="m3.973 13.14 6.078-6.078 6.077 6.078 1.179-1.179-7.256-7.256-7.256 7.256 1.178 1.179Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowUp24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowUp24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="m4.768 15.768 7.292-7.293 7.293 7.293 1.415-1.415-8.708-8.707-8.706 8.707 1.414 1.415Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconArrowUp = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowUp(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconArrowUp8 {...iconProps} />;
        case '12':
            return <IconArrowUp12 {...iconProps} />;
        case '16':
            return <IconArrowUp16 {...iconProps} />;
        case '20':
            return <IconArrowUp20 {...iconProps} />;
        case '24':
            return <IconArrowUp24 {...iconProps} />;
        default:
            return <IconArrowUp24 {...iconProps} />;
    }
});
